
import 'pages/comments/comments-list.tag'
import 'pages/comments/comment-edit.tag'
riot.tag2('comments', '  <div class="column" if="{!notFound}">\n    <comments-list if="{!edit}"></comments-list>\n    <comment-edit if="{edit}"></comment-edit>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create();

self.edit = false;

route('/reviews/comments', function () {
    self.notFound = false;
    self.edit = false;
    self.update();
});

route('/reviews/comments/([0-9]+)', function (id) {
    observable.trigger('comment-edit', id);
    self.notFound = false;
    self.edit = true;
    self.update();
});

route('/reviews/comments/new', function () {
    self.notFound = false;
    self.edit = true;
    observable.trigger('comment-new');
    self.update();
});

route('/reviews/comments..', function () {
    self.notFound = true;
    self.update();
    observable.trigger('not-found');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/comments/comments.tag